/* eslint-disable react/jsx-props-no-spreading */
import React from 'react';
import './ProgressBar.style.scss';
import { useTranslation } from 'react-i18next';
import ProgressBar, { IProgressBarProps } from 'components/UI_kit_3/ProgressBar/ProgressBar';
import Card from 'components/UI_kit_3/Card/Card';

interface IProgressBarCustomProps extends IProgressBarProps {
  label: string
}

const ProgressBarCustom:React.FC<IProgressBarCustomProps> = ({
  className, progress, label, ...props
}) => {
  const [t] = useTranslation();
  return (
    <Card size="sm" className={className}>
      <div className="text-secondary font-sm-medium mb-sm">
        <div>{label}</div>
        {
      progress === 0 && (
        <span className="font-sm-regular">{t('backup.queued')}</span>
      )
    }
      </div>
      <ProgressBar progress={progress} {...props} />
    </Card>
  );
};

export default ProgressBarCustom;
